import React from 'react';
import { Link } from 'react-router-dom'; // Link import karna zaroori hai

const Header = () => {
  return (
    <header className="bg-white">
      {/* Top Bar: Icons, Search, Language */}
      <div className="container py-2 border-bottom">
        <div className="row align-items-center">
          {/* Left Icons */}
          <div className="col-md-4 d-flex gap-3 align-items-center">
             <Link to="/" className="text-secondary"><i className="fa fa-home fs-5"></i></Link>
             <Link to="/messages" className="text-secondary"><i className="fa fa-envelope fs-5"></i></Link>
             <Link to="/rss" className="text-secondary"><i className="fa fa-rss fs-5"></i></Link>
             <Link to="/live" className="text-danger"><i className="fa fa-broadcast-tower fs-5"></i> LIVE</Link>
          </div>

          {/* Center Search */}
          <div className="col-md-4">
            <div className="input-group input-group-sm">
                <input type="text" className="form-control border-end-0" placeholder="Search on site ..." />
                <span className="input-group-text bg-white border-start-0"><i className="fa fa-search text-muted"></i></span>
            </div>
          </div>

          {/* Right Language */}
          {/* <div className="col-md-4 text-end fw-bold" style={{fontSize: '12px'}}>
            <span className="text-primary mx-1">RO</span>
            <span className="text-muted mx-1">EN</span>
            <span className="text-muted mx-1">RU</span>
          </div> */}
        </div>
      </div>

      {/* Main Logo Section - AB CLICKABLE HAI */}
      <div className="container py-4 text-center">
        {/* Yahan Link lagaya hai jo Home ("/") par le jayega */}
        <Link to="/" style={{textDecoration: 'none'}}> 
            <div className="d-flex justify-content-center align-items-center gap-3">
            <img src="/images/logo.svg" alt="Coat of Arms" style={{width: '80px', height: 'auto'}} />
            <div className="text-start">
                <h2 className="text-uppercase text-primary mb-0" style={{fontFamily: 'serif', letterSpacing: '1px', color: '#003366'}}>GOVERNMENT</h2>
                <h6 className="text-uppercase text-secondary mb-0" style={{letterSpacing: '3px', fontSize: '12px'}}>OF REPUBLIC OF MOLDOVA</h6>
            </div>
            </div>
        </Link>
      </div>
    </header>
  );
};

export default Header;